import React, { useRef } from 'react';

import ModalPhotoBase from './ModalPhotoBase';

import PhotoBg from '../../../../../Images/modals/photographers/carlos/bg_carlos.png';
import Photo1 from '../../../../../Images/modals/photographers/carlos/photo-1.png';
import Photo2 from '../../../../../Images/modals/photographers/carlos/photo-2.png';
import Photo3 from '../../../../../Images/modals/photographers/carlos/photo-3.png';
import Photo4 from '../../../../../Images/modals/photographers/carlos/photo-4.png';

import {
  Photo_Carlos,
  Text_Carlos,
  TextPhoto1_Carlos,
  TextPhoto2_Carlos,
  TextPhoto3_Carlos,
  TextPhoto4_Carlos,
} from '../../../../../utils/EN/Modals/photographers';

const ModalPhotoCarlos = () => {
  return (
    <>
      <ModalPhotoBase
        id="photo-carlos"
        mainBg={PhotoBg}
        directorName={Photo_Carlos}
        mainVideoBg={Photo1}
        videoText1={TextPhoto1_Carlos}
        directorText={Text_Carlos}
        rowImage1={Photo2}
        videoText2={TextPhoto2_Carlos}
        rowImage2={Photo3}
        videoText3={TextPhoto3_Carlos}
        rowImage3={Photo4}
        videoText4={TextPhoto4_Carlos}
        mainGallery={'carlos-gallery-1'}
        gallery2={'carlos-gallery-2'}
        gallery3={'carlos-gallery-3'}
        gallery4={'carlos-gallery-4'}
      />
    </>
  );
};

export default ModalPhotoCarlos;
